import React, { Component } from 'react';

import SearchInput from '../../../Packages/SharedComponents/Com.Gyf.WebCore.SearchInput.jsx';

import HeaderButtons from './HeaderButtons.jsx';
import HeaderCheckbox from './HeaderCheckbox.jsx';

const BACK_KEY_CODE = 8;
const ENTER_KEY_CODE = 13;
const DELETE_KEY_CODE = 46;

class Headers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchUser: ""
        }

        this.limpiarFiltro = this.limpiarFiltro.bind(this);
    }

    limpiarFiltro() {
        this.setState({ searchUser: "" });

        this.props.searchUser("");
    }

    //BOTONES, BUSCADOR Y CHECKS (CABECERA)
    render() {
        let searchInputAttr = {
            maxLength: 40,
            className: "form-control default-input",
            placeholder: "Buscar por nombre o login...",
            value: this.state.searchUser
        };

        return (
            <div className="row user-list bottom-separator-xxs">
                <div className="col-md-4" style={{ padding: 0 }}>
                    <HeaderButtons
                        functions={this.props.functions}
                        usuariosFiltrados={this.props.usuariosFiltrados}
                        setMotivoBloqueo={this.props.setMotivoBloqueo}
                        setUserState={this.props.setUserState}
                        asignarPerfil={this.props.asignarPerfil}
                        tipoOperacion={this.props.tipoOperacion}
                        desasignarPerfil={this.props.desasignarPerfil}
                    />
                </div>

                <div className="col-md-8">
                    <div className="row">
                        <div className="col-md-6">
                            <SearchInput caller="headers"
                                listSource={this.props.usuarios}
                                automaticSearch="true" 
                                onChangeHandle={(event) => this.handleChange(event)}
                                onKeyUp={(event) => this.handleKeyUp(event)}
                                {...searchInputAttr} />
                        </div>

                        {this.state.searchUser.length > 0 ?
                        <div className="AsignarPerfilAUsuario-btn-group-Borrar-Filtro">
                            <button id={"botonBorrarFiltroBuscarEntidad"} type="button" className="btn-tag AsignarPerfilAUsuario-Filtros-Limpiar-Filtro"
                                onClick={this.limpiarFiltro}>
                                <span id={"botonBorrarXFiltroBuscarEntidad"} className="ti-close span-closable" />
                            </button>
                        </div>
                        :
                        null}

                        {(this.props.tipoOperacion == 2) ?
                            <div>
                                <div className="col-md-2">
                                    <label>
                                        <HeaderCheckbox
                                            title="Activos"
                                            name="activos"
                                            index={1}
                                            setActivosCheckbox={this.props.setActivosCheckbox}
                                            setBloqueadosCheckbox={this.props.setBloqueadosCheckbox}
                                            setEliminadosCheckbox={this.props.setEliminadosCheckbox}
                                        />
                                    </label>
                                </div>
                                <div className="col-md-2 no-padding">
                                    <label>
                                        <HeaderCheckbox
                                            title="Bloqueados"
                                            name="bloqueados"
                                            index={2}
                                            setActivosCheckbox={this.props.setActivosCheckbox}
                                            setBloqueadosCheckbox={this.props.setBloqueadosCheckbox}
                                            setEliminadosCheckbox={this.props.setEliminadosCheckbox}
                                        />
                                    </label>
                                </div>
                                <div className="col-md-2 no-padding">
                                    <label>
                                        <HeaderCheckbox
                                            title="Eliminados"
                                            name="eliminados"
                                            index={3}
                                            setActivosCheckbox={this.props.setActivosCheckbox}
                                            setBloqueadosCheckbox={this.props.setBloqueadosCheckbox}
                                            setEliminadosCheckbox={this.props.setEliminadosCheckbox}
                                        />
                                    </label>
                                </div>
                            </div> : <div></div>}
                    </div>
                </div>
            </div>
        );
    }

    handleChange(event) {
        const term = event.target.value;
        this.setState({ searchUser: term });

        if (term.length >= 2 || term == "") {
            this.props.searchUser(term.toUpperCase());
        }
    }

    handleKeyUp(event) {
        if (event.keyCode === ENTER_KEY_CODE || event.keyCode === DELETE_KEY_CODE || event.keyCode === BACK_KEY_CODE) {
            this.props.searchUser(event.target.value.toUpperCase());
        }
    }
};

export default Headers;